import $ from "jquery";

class Input {

    constructor(element) {
        this.formGroup = element;
        this.input = element.querySelector(".form-control");

        if (this.input === null) return;

        this.input.addEventListener("focus", this.handleChange.bind(this));
        this.input.addEventListener("blur", this.handleChange.bind(this));
        this.input.addEventListener("keyup", this.handleChange.bind(this));
        this.input.addEventListener("keydown", this.handleChange.bind(this));
        this.input.addEventListener("change", this.handleChange.bind(this));
        this.input.addEventListener("input", this.handleChange.bind(this));

	    this.handleChange();
    }

    handleChange() {
        // check to see if we want to override stacking the label to the top left
        if (!this.formGroup.hasAttribute("perma-set")) {
            if (this.input.value && this.input.value.length > 0 || this.input.disabled) {
                this.formGroup.classList.add("has-value");
            } else {
                this.formGroup.classList.remove("has-value");
            }
        }

        if (this.input === document.activeElement) {
	        this.formGroup.classList.add("has-focus");
        } else {
	        this.formGroup.classList.remove("has-focus");
        }
    }
}

document.addEventListener("DOMContentLoaded",
    () => {
        for (let element of document.querySelectorAll(".form-group")) {
            new Input(element);
        }
    });


function handleFormSubmits(e) {

    console.log("submitted");
    const form = $(e.currentTarget);

    if (form.valid()) {
        if (this.submitted) {
            e.preventDefault();
            e.stopImmediatePropagation();
        }
        this.submitted = true;
        const buttons = form.find('button[type="submit"]');
        if (buttons.length > 0) {
            const button = $(buttons[0]);
            button.css("height", button.outerHeight());
            button.addClass("loading");
            button.text("");
        }
    }

};

document.addEventListener("DOMContentLoaded",
    () => {
        for (let form of document.querySelectorAll("form")) {
            form.addEventListener("submit", handleFormSubmits);
        }
    });